var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar",class:_vm.overlayClass,style:({
        height: ((_vm.height || 20) + "px"),
    })},[_c('div',{staticClass:"progress-fill",class:_vm.fillClass,style:({
            width: (_vm.percent + "%"),
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }